import { useSelector } from "react-redux";
import { SettingsState } from "../../redux/settings-slice";
import { AppState } from "../../redux/store";


/**
 * Retrieves application-level settings from the redux store.
 * @returns App settings object aggregated during bootstrap.
 */
export function useSettings() {

    const _state = useSelector<AppState>(state => state.settings) as SettingsState;
    return _state.appSettings;
}